import { mapToCanActivate, Routes } from '@angular/router';
import { NetzbetreiberPageComponent } from './netzbetreiber-page/netzbetreiber-page.component';
import { NetzbetreiberDetailComponent } from './netzbetreiber-detail/netzbetreiber-detail.component';
import { AuthGuard } from '../service/auth/auth.guard';
import { RoleAuthGuard } from '../service/auth/role-auth.guard';
import { UserRoles } from '../domain/model/roles.enum';

export const netzbetreiberRoutes: Routes = [
    {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full',
    },
    {   // lists all Netzbetreiber
        path: 'list',
        component: NetzbetreiberPageComponent,
        canActivate: mapToCanActivate([
            AuthGuard,
            RoleAuthGuard,
        ]),
        data: {
            allowedRoles: [
                UserRoles.ADMIN_USER,
                UserRoles.WESTNETZ_USER,
            ],
        },
    },
    {
        path: 'detail',
        component: NetzbetreiberDetailComponent,
        canActivate: mapToCanActivate([
            AuthGuard,
            RoleAuthGuard,
        ]),
        data: {
            allowedRoles: [
                UserRoles.ADMIN_USER,
                UserRoles.VNB_USER,
                UserRoles.WESTNETZ_USER,
            ],
        },
    },
];
